<template>
  <div>
    <Breadcrumbs :title="$t('mnimReytinqim')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-7">
          <h2>{{ $t('mnimReytinqim') }}</h2>

          <div
            v-for="(a,i) in actions"
            :key="i"
            class="card"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <div
                    class="h2"
                    :class="{'text-danger': a.points<0, 'text-success': a.points>0 }"
                  >
                    {{ a.points }}
                  </div>
                </div>
                <div class="col-6 text-right">
                  {{ getMoment(a.logTime) }}
                </div>
                <div class="col-12">
                  {{ getMessage(a) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-5">
          <div
            v-if="ratingRules !== null"
            class="user-cards"
          >
            <div class="card custom-card">
              <router-link
                target="_blank"
                :to="{path: '/dashboard/page/rating_rules'}"
              >
                <img
                  :src="`${mediaBase}/${ratingRules.banner}`"
                  class="w-100"
                  alt=""
                >
              </router-link>
            </div>
          </div>

          <div
            v-if="top10 !== null"
            class="user-cards"
          >
            <div class="card custom-card">
              <router-link
                target="_blank"
                :to="{path: '/dashboard/page/rating_leaderboard'}"
              >
                <img
                  :src="`${mediaBase}/${top10.banner}`"
                  class="w-100"
                  alt=""
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getMyRatingHistory, getPage
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import moment from "moment/moment";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      actions: [],
      top10: null,
      ratingRules: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {

    this.getMyRatingHistory();

    getPage(this.token, 'rating_rules').then(d => {

      if (d.code === 200) {
        this.ratingRules = d.data;
      }

    });
    getPage(this.token, 'rating_leaderboard').then(d => {

      if (d.code === 200) {
        this.top10 = d.data;
      }

    })

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale)
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getMyRatingHistory() {
      getMyRatingHistory(this.token, 1).then(data => {
        this.actions = data;
      })
    },
    //TODO LANGUAGE
    calculatePeriodText(duration) {
      let step = "0";
      if (duration === "1") {
        step = this.$t("in1Min");
      } else if (duration === "10") {
        step = this.$t("in10Min");
      } else if (duration === "1h") {
        step = this.$t("in1Hour");
      } else if (duration === "8h") {
        step = this.$t("in8Hours");
      } else if (duration === "1d") {
        step = this.$t("in1Day");
      } else {
        step = "";
      }
      return step;
    },
    getMessage(item) {
      let message = item.reason;
      if (item.reason === 'not_active_3') {
        message = this.$t("pgrmDxlOlmadigini");
      } else {
        let reasonParts = item.reason.split("_");

        switch (reasonParts[2]) {
          case "create":
            message = this.$t(srgnYrtd, {reason: reasonParts[1]});
            break;
          case "comment":
            message = this.$t("rateComment", {
              calculatePeriodText: this.calculatePeriodText(reasonParts[2]),
              reason: reasonParts[1],
              reason2: reasonParts[1] === 'RFQ' ? this.$t('qymtTklfGr') : this.$t("forCommnet")
            })
            break;
          case "report":
            message = this.$t("report", {reason: reasonParts[1]});
            break;
          case "conversation_start":
            message = this.$t("mzkrBsldgGr");
            break;
        }
      }
      return message;
    }
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
